import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function CustomColumnsFormatter({ info, value }) {
  const { row } = getInfo(info)

  if (row.custom) {
    const column = JSON.parse(row.custom)
    return column[value] || ''
  }

  return null
}
